<template>
  <div class="container-fluid callToContact">
    <div class="callToContact__header">
      <h4>{{ title }}</h4>
      <p>
        {{ subTitle }}
      </p>
    </div>
    <section class="callToContact-icons">
      <a
        class="callToContact-icons__card callToContact-icons__card--call bg-blue"
        href="tel:+33787185918"
      >
        <div class="callToContact-icons__group">
          <p class="yellow">Nous appeler</p>
          <div class="allIcons">
            <img
              src="@/assets/icons/icons-appel-yellow.webp"
              alt="icon-taxi"
              loading="lazy"
            />
          </div>
        </div>
      </a>
      <a
        class="callToContact-icons__card callToContact-icons__card--sms bg-yellow"
        href="sms:+33787185918"
      >
        <div class="callToContact-icons__group">
          <p class="blue">Posez votre question par SMS</p>
          <div class="allIcons">
            <img
              src="@/assets/icons/icons-sms-blue.webp"
              alt="icon-sms"
              loading="lazy"
            />
          </div>
        </div>
      </a>
      <a
        class="callToContact-icons__card callToContact-icons__card--callback bg-yellow"
        @click.prevent="showCallForm"
        href="#"
      >
        <div class="callToContact-icons__group">
          <p class="blue">
            Vous souhaitez être
            <span class="callToContact-icons__nowrap">appelé&nbsp;?</span>
          </p>
          <div class="allIcons">
            <img
              src="@/assets/icons/icons-incoming.webp"
              alt="icon-incoming-call"
              loading="lazy"
            />
          </div>
        </div>
      </a>
      <a
        class="callToContact-icons__card callToContact-icons__card--meeting bg-blue"
        href="/contact"
      >
        <div class="callToContact-icons__group">
          <p class="yellow">Prendre un rendez-vous</p>
          <div class="allIcons">
            <img
              src="@/assets/icons/icons-calendar.webp"
              alt="icon-calendar"
              loading="lazy"
            />
          </div>
        </div>
      </a>
    </section>
    <span v-if="callMeMaybe">
      <section class="col-10 col-lg-5 formulaire">
        <span class="close-cross" @click="closeOrder">X</span>
        <div class="formulaire__header">
          <p>
            Laissez nous vos coordonnées notre équipe vous recontact en moins de
            24h.<span>*</span><br />
            <span>*</span>(24h ouvrées)
          </p>
        </div>
        <form ref="formData" @submit.prevent="sendEmail">
          <div class="form">
            <div class="col">
              <input
                type="hidden"
                name="reason"
                value="Demande d'appel"
                required
              />
            </div>
            <div class="col">
              <input
                type="text"
                placeholder="Votre Nom"
                name="name"
                maxlength="30"
                required
              />
            </div>
            <div class="col">
              <input
                type="tel"
                placeholder="Votre Téléphone"
                name="phone"
                required
                pattern="^(\+?\d{1,3}[- ]?)?\d{10}$"
              />
            </div>
            <button name="button" type="submit">Envoyer</button>
          </div>
        </form>
        <span v-if="this.modalConfirm">
          <ConfirmModal
            @closeModalConfirm="closeModalConfirm"
            title="Merci de votre intérêt"
            message="Vous allez être recontactés dans les plus brefs délais"
            btnExit="À bientôt"
          />
        </span>
      </section>
    </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
export default {
  name: "CallTocontact",
  components: { ConfirmModal },
  props: {
    title: {
      type: String,
      default: undefined,
    },
    subTitle: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      callMeMaybe: false,
      modalConfirm: false,
    };
  },
  computed: {
    ...mapGetters({
      SendingEmail: "StateSendingEmail",
      EmailSent: "StateEmailSent",
      EmailError: "StateEmailError",
    }),
  },
  methods: {
    ...mapActions(["SendCallMeMail"]),
    sendEmail() {
      this.SendCallMeMail(this.$refs.formData);
      this.modalConfirm = true;
      this.$refs.formData.reset();
    },
    closeModalConfirm() {
      this.modalConfirm = false;
      this.callMeMaybe = false;
    },
    showCallForm() {
      this.callMeMaybe = true;
    },
    closeOrder() {
      this.callMeMaybe = false;
    },

    goCalendar() {
      this.$router.push({ path: "/contact", hash: "calendar" });
    },
  },
};
</script>

<style lang="scss" scoped>
.callToContact {
  margin: 82px 0 96px;

  @media screen and (min-width: 992px) {
    margin: 104px 0 118px;
  }

  &__header {
    text-align: center;
    padding-inline: 14px;

    @media screen and (min-width: 992px) {
      padding-inline: 0;
    }

    & h4 {
      font-family: "adam";
      font-size: clamp(2rem, 4vw, 3.2rem);
      line-height: 1.08;
      margin: 0;
      color: $color-primary;
    }

    & p {
      max-width: 1240px;
      text-align: center;
      margin: 28px auto 38px;
      padding-inline: 4px;
      font-size: clamp(1.14rem, 1rem + 0.3vw, 1.28rem);
      line-height: 1.68;

      @media screen and (min-width: 992px) {
        margin: 34px auto 46px;
        padding-inline: 0;
      }
    }
  }

  & .callToContact-icons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    align-items: stretch;
    width: min(100%, 420px);
    margin: 0 auto;

    @media screen and (min-width: 768px) {
      gap: 8px;
    }

    @media screen and (min-width: 992px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      width: min(100%, 980px);
      gap: 10px;
    }

    &__card {
      display: block;
      width: 100%;
      aspect-ratio: 1 / 1;
      min-height: 0;
      padding: 12px;
      border-radius: 0;
      text-decoration: none;
      transition: transform 0.22s ease, box-shadow 0.22s ease,
        border-color 0.22s ease;
      box-shadow: rgba(0, 16, 32, 0.14) 0px 10px 18px;

      &:hover,
      &:focus,
      &:active {
        text-decoration: none;
      }

      @media screen and (min-width: 992px) {
        aspect-ratio: auto;
        min-height: 148px;
        padding: 16px 18px;
      }

      &:hover {
        transform: translateY(-2px);
      }
    }

    &__card--call {
      border-top-left-radius: 22px;
    }

    &__card--sms {
      border-top-right-radius: 22px;
    }

    &__card--callback {
      border-bottom-left-radius: 22px;
    }

    &__card--meeting {
      border-bottom-right-radius: 22px;
    }

    & .bg-blue {
      background-color: $color-primary;
      border: 1px solid rgba(255, 255, 255, 0.08);
    }

    & .bg-yellow {
      background-color: $color-secondary;
      border: 1px solid rgba(0, 42, 84, 0.08);
    }

    &__group {
      min-height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      gap: 10px;

      & img {
        width: clamp(32px, 9vw, 52px);

        @media screen and (min-width: 992px) {
          width: 50px;
        }
      }

      & p {
        font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
        font-size: clamp(0.82rem, 0.78rem + 0.12vw, 0.94rem);
        font-weight: 800;
        line-height: 1.14;
        text-align: center;
        margin: 0;
        letter-spacing: 0.01em;
        text-decoration: none;

        @media screen and (min-width: 992px) {
          font-size: 0.94rem;
          line-height: 1.18;
          text-align: left;
        }
      }

      & .yellow {
        color: $color-text-light;
      }

      & .blue {
        color: $color-primary;
      }

      & .allIcons {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      @media screen and (min-width: 992px) {
        flex-direction: row;
        justify-content: space-between;
        gap: 14px;
        text-align: left;

        & .allIcons {
          flex: 0 0 auto;
        }
      }
    }

    &__nowrap {
      white-space: nowrap;
    }
  }
  & .formulaire {
    position: fixed;
    top: 58%;
    left: 50%;
    width: 90%;
    max-width: 800px;
    transform: translate(-50%, -50%);
    z-index: 500;
    padding: 10px 50px 20px;
    background-color: $color-primary;
    border: 0.5px outset $color-secondary;
    border-radius: 10px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    .close-cross {
      position: fixed;
      top: -10px;
      left: -10px;
      display: inline;
      color: $color-secondary;
      @include black-gradient;
      padding: 5px 6px;
      border-radius: 50%;
      font-size: 1em;
      cursor: pointer;
      box-sizing: content-box;
      transition: 0.4s;
      @media screen and (min-width: 992px) {
        top: -28px;
        left: -18px;
      }
      &:hover {
        border: 0.1px outset rgba(255, 0, 0, 0.685);
        color: rgba(255, 0, 0, 0.685);
      }
    }
    &__header {
      margin: 10px 0px 20px;
      & p {
        color: $color-text-light;
        font-size: 1em;
        text-align: center;
        & span {
          color: $color-secondary;
        }
      }
    }

    h2 {
      text-align: center;
      text-transform: uppercase;
    }
    & .form {
      background-color: $color-secondary;
      padding: 20px 10px 20px;
      border-radius: 5px;
      text-align: center;
      input {
        margin-bottom: 20px;
        width: 90%;
        padding: 10px;
        border-radius: 10px;
        &:focus {
          box-shadow: 1px 1px 3px black;
        }
        &::placeholder {
          color: $color-primary;
        }
      }
      button {
        border: none;
        padding: 7px 20px;
        border-radius: 100px;
        font-size: 1em;
        letter-spacing: 1px;
        background-color: $color-primary;
        color: white;
        opacity: 0.8;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.884);
        transition: 0.3s;
        &:hover {
          opacity: 1;
          scale: 96%;
        }
        &:active {
          scale: 96%;
          box-shadow: 1px 1px 3px black;
        }
      }
    }
  }
}
</style>
